import React from 'react';
import { type FieldValues, type UseFormReturn } from 'react-hook-form';

interface FormProps {
    children: React.ReactNode;
    onFinish?: (data: FieldValues) => void;
    formInstance?: UseFormReturn<FieldValues>;
    defaultValues?: FieldValues;
    className?: string;
}

// Simple form component that doesn't use hooks - relies on native form submission
const Form: React.FC<FormProps> = ({ children, onFinish, className = '' }) => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (onFinish) {
            // Extract form data without using react-hook-form
            const formData = new FormData(event.currentTarget);
            const data: FieldValues = {};

            for (const [key, value] of formData.entries()) {
                data[key] = value;
            }

            onFinish(data);
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className={`malachite-form space-y-4 ${className}`}
            style={{
                fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                lineHeight: '1.5',
                width: '100%',
            }}
        >
            {children}
        </form>
    );
};

export default Form;
